export default __webpack_public_path__ + "static/Noroutine_Logo-ac073e534d124b61162a3dff022f68c9.svg";